import { gql } from "@apollo/client";

export default gql`
  query getOffers($projectId: String) {
    offers(projectId: $projectId) {
      id
      name
      description
      status
      projectId
    }
  }
`;
